import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { DateRangeType } from 'office-ui-fabric-react/lib/utilities/dateValues/DateValues';

export const toggleShowDeclinedEventsMode = action(
    'toggleShowDeclinedEventsMode',
    (isDeclinedEventsMode: boolean, dateRangeType: DateRangeType) =>
        addDatapointConfig(
            {
                name: 'ToggleShowDeclinedEventsMode',
                customData: {
                    CurrentDateRangeType: dateRangeType,
                    ShowDeclinedEventsMode: isDeclinedEventsMode, // log the intended state after toggle
                },
            },
            {
                isDeclinedEventsMode,
                dateRangeType,
            }
        )
);

export default toggleShowDeclinedEventsMode;
